package app.view

import app.CustomRouter
import app.Routes
import app.api.DeployablesApi
import app.api.ProjectReleasesPaginatedApi
import app.api.ProjectStepApi
import app.components.*
import app.svg.*
import app.utils.formatDateTime
import dev.fritz2.core.*

fun RenderContext.projectReleasesPaginatedView(
    projectStepApi: ProjectStepApi,
    projectReleasePaginatedApi: ProjectReleasesPaginatedApi,
    deployablesApi: DeployablesApi,
    projectId: String?,
    page: Int,
    sort: String,
    order: String,
) {
    val showCreateReleaseMenu = storeOf(false)
    val showModalStore = storeOf(ModalStore(show = false, message = ""))
    warningModal(
        modalStore = showModalStore,
    )

    if (projectId == null) {
        CustomRouter.navTo(mapOf("route" to Routes.PROJECTS))
        return
    }

    projectReleasePaginatedApi.handler(
        ProjectReleasesPaginatedApi.PaginationRequest(
            projectId = projectId,
            sort = sort,
            order = order,
            page = page,
        )
    )
    projectReleasePaginatedApi.data.render { releases ->
        deployablesApi.handler(Unit)
        deployablesApi.data.render { latestDeployables ->
            div("flex gap-4 dark:text-white") {
                sidebarNavigation(projectId)
                div("basis-10/12 border rounded-md shadow-md my-4 p-4 dark:bg-gray-800 dark:border-gray-700") {
                    showCreateReleaseMenu.data.render { show ->
                        div("flex justify-between mb-4 items-center") {
                            h3("font-semibold p-2") {
                                +"Releases"
                            }
                            button("px-2 py-2 bg-blue-500 text-white rounded") {
                                if (show) {
                                    close("size-6")
                                } else {
                                    plus("size-6")
                                }
                                clicks handledBy { showCreateReleaseMenu.update(!show) }
                            }
                        }
                        if (show) {
                            releaseCreationForm(
                                projectId = projectId,
                                showCreateReleaseMenu = showCreateReleaseMenu,
                                projectStepApi = projectStepApi,
                                latestDeployables = latestDeployables,
                                projectReleasePaginatedApi = projectReleasePaginatedApi,
                            )
                        }
                    }
                    div("relative overflow-x-auto shadow-md sm:rounded-lg mt-4 border dark:border-gray-700") {
                        table("w-full text-sm text-left text-gray-500 dark:text-gray-400 dark:bg-gray-700 dark:text-gray-300") {
                            thead("text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-600 dark:text-gray-300"){
                                tr {
                                    th("px-6 py-3 dark:text-gray-300") {
                                        scope("col")
                                        button("flex text-center ${if (sort == "version") "underline" else ""}") {
                                            +"VERSION"
                                            sort("w-3 h-3 ms-1.5")
                                            clicks handledBy {
                                                CustomRouter.releases(
                                                    mapOf(
                                                        "route" to Routes.RELEASES,
                                                        Routes.Params.PROJECT_ID to projectId,
                                                        Routes.Params.SORT to "version",
                                                        Routes.Params.ORDER to if (order == "asc") "desc" else "asc",
                                                        Routes.Params.PAGE to "1"
                                                    )
                                                )
                                            }
                                        }
                                    }
                                    th("px-6 py-3 dark:text-gray-300") {
                                        scope("col")
                                        button("flex text-center ${if (sort == "date") "underline" else ""}") {
                                            +"DATE"
                                            sort("w-3 h-3 ms-1.5")
                                            clicks handledBy {
                                                CustomRouter.releases(
                                                    mapOf(
                                                        "route" to Routes.RELEASES,
                                                        Routes.Params.PROJECT_ID to projectId,
                                                        Routes.Params.SORT to "date",
                                                        Routes.Params.ORDER to if (order == "asc") "desc" else "asc",
                                                        Routes.Params.PAGE to "1"
                                                    )
                                                )
                                            }
                                        }
                                    }
                                }
                            }
                            tbody {
                                releases.items.forEach { release ->
                                    tr("bg-white border-b group dark:bg-gray-700 dark:border-gray-700") {
                                        td("px-6 py-4 dark:text-gray-300") {
                                            button("hover:underline") {
                                                +release.version.toString()
                                                clicks handledBy {
                                                    CustomRouter.release(
                                                        mapOf(
                                                            "route" to Routes.RELEASE,
                                                            Routes.Params.PROJECT_ID to projectId,
                                                            Routes.Params.RELEASE_ID to release.id.toString(),
                                                        )
                                                    )
                                                }
                                            }
                                        }
                                        td("px-6 py-4 flex justify-between dark:text-gray-300") {
                                            div {
                                                +formatDateTime(release.createdAt)
                                            }
                                            button("invisible group-hover:visible") {
                                                delete("size-6")
                                                clicks handledBy {
                                                    showModalStore.update(
                                                        ModalStore(
                                                            show = true,
                                                            message = "Are you sure you want to delete " +
                                                                    "${release.version}? Deleting the release will " +
                                                                    "automatically delete all associated " +
                                                                    "rollout executions.",
                                                            onConfirm = {
                                                                projectReleasePaginatedApi.deleteProjectRelease(
                                                                    release.id
                                                                )
                                                            }
                                                        )
                                                    )
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    div("mt-4 flex justify-center") {
                        pagination(
                            currentPage = releases.currentPage,
                            totalPages = releases.totalPages
                        ) { newPage ->
                            CustomRouter.releases(
                                mapOf(
                                    "route" to Routes.RELEASES,
                                    Routes.Params.PROJECT_ID to projectId,
                                    Routes.Params.SORT to sort,
                                    Routes.Params.ORDER to order,
                                    Routes.Params.PAGE to newPage.toString()
                                )
                            )
                        }
                    }
                }
            }
        }
    }
}
